<template>
  <div class="van-tabs-content item4">
    <div
      class="item4-content-box"
      v-for="(item, index) in listData"
      :key="index"
    >
      <div class="day-style">{{ item.date }}</div>
      <div
        class="item1-content-card"
        v-for="(item1, idx) in item.cards"
        :key="'card' + idx"
      >
        <div class="time-identity">
          <div class="time">{{ item1.time }}</div>
        </div>
        <div class="card">
          <div class="title">{{ item1.title }}</div>
          <div class="address">暨南大学科学馆国际会议厅</div>
          <div class="position" v-show="item1.position">A区-2排13号</div>
        </div>
        <div class="left-style">
          <div class="circular"></div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "infoItem4",
  data() {
    return {
      listData: [
        {
          date: "2023.9.20",
          cards: [
            {
              time: "13:00-14:00",
              identity: "主持人",
              identityClass: "green",
              title: "自助午餐",
              address: "暨南大学科学馆国际会议厅",
              position: "",
            },
            {
              time: "13:00-14:00",
              identity: "发言嘉宾",
              identityClass: "blue",
              title: "自助晚餐",
              address: "暨南大学科学馆国际会议厅",
              position: "",
            },
          ],
        },
        {
          date: "2023.9.20",
          cards: [
            {
              time: "13:00-14:00",
              identity: "主持人",
              identityClass: "green",
              title: "自助午餐",
              address: "暨南大学科学馆国际会议厅",
              position: "A区-2排13号",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.van-tabs-content.item4 {
  .item4-content-box {
    position: relative;
    margin: 0 0 25px;
    .day-style {
      margin: 0 0 2px;
      width: 107px;
      height: 38px;
      padding-left: 10px;
      background: url("~@/assets/img/day_bg.png") no-repeat;
      background-size: contain;
      box-sizing: border-box;
      font-size: 15px;
      font-family: GalanoGrotesqueDEMO-Bold, GalanoGrotesqueDEMO;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      text-align: left;
    }
    .item1-content-card {
      position: relative;
      padding-left: 20px;
      padding-bottom: 15px;
      &:last-child {
        .left-style .line {
          display: none;
        }
      }
      .time-identity {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 0 8px;
        .time {
          font-size: 14px;
          font-family: Helvetica;
          color: #ffffff;
          line-height: 17px;
        }
      }
      .card {
        padding: 15px;
        border-radius: 4px 0px 0px 4px;
        background: linear-gradient(
          270deg,
          rgba(94, 113, 215, 0) 0%,
          #303dae 100%
        );
        border-image: linear-gradient(
            270deg,
            rgba(69, 132, 199, 0),
            rgba(71, 137, 199, 0.4)
          )
          1 1;
        text-align: left;
        .title {
          margin: 0 0 8px;
          font-size: 15px;
          font-weight: 500;
          color: #ffffff;
          line-height: 20px;
        }
        .address,
        .position {
          position: relative;
          padding-left: 21px;
          font-size: 13px;
          font-weight: 400;
          color: rgba($color: #fff, $alpha: 0.6);
          line-height: 21px;
        }
        .address::before,
        .position::before {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 16px;
          height: 16px;
        }
        .address::before {
          background: url("~@/assets/img/address_icon.png");
          background-size: contain;
        }
        .position::before {
          background: url("~@/assets/img/position_icon.png");
          background-size: contain;
        }
        .position {
          margin: 5px 0 0;
        }
      }
      .left-style {
        position: absolute;
        left: 0;
        top: 0px;
        bottom: 0;
        .circular {
          position: relative;
          width: 14px;
          height: 14px;
          background: url("~@/assets/img/ic_circular_green.png") center
            no-repeat;
          background-size: contain;
        }
        .line {
          width: 1px;
          margin: 8px auto 0;
          height: calc(100% - 22px);
          background-image: linear-gradient(
            to bottom,
            #3eb134 0%,
            #3eb134 10%,
            transparent 20%
          );
          background-size: 1px 10px;
          background-repeat: y-repeat;
        }
      }
    }
  }
}
</style>
